import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = [];

const nominatedSellersReducerMap = {
	[types.SET_NOMINATED_SELLERS]: (state, action) => {
		return action.payload.logins;
	},
	[types.NOMINATE_SELLER]: (state, action) => {
		return state.concat(action.payload.login);
	},
	[types.DISCARD_SELLER]: (state, action) => {
		return state.filter((login) => login !== action.payload.login);
	},
	[types.RESET_NOMINATIONS]: () => {
		return initialState;
	},
};

export default handleActions(nominatedSellersReducerMap, initialState);
